import { minLength, maxLength, stringPattern, tagMaxLength, tagMinLength } from '../../utils/form-validations';

export const factoryDefaultFields = {
  factory_name: '',
  no_of_egs: 0,
  no_of_assets: 0,
  no_of_machines: 0,
  onto_manage_id: null,
};

// Use Case
export const factoryUISchema = [
  { id: 1, label: 'Country', name: 'onto_manage_id', type: 'select', required: true },
  { id: 2, label: 'Name of Factory', name: 'factory_name', type: 'input', required: true },
];

export const factorySchema = {
  type: 'object',
  properties: {
    onto_manage_id: { type: 'number', minLength: 1, maxLength },
    factory_name: { type: 'string', minLength, maxLength, pattern: stringPattern },
  },
  required: ['onto_manage_id', 'factory_name'],
  additionalProperties: true,
};

export const factoryMetaDataSchema = {
  type: 'object',
  properties: {
    id: { type: 'number' },
    key: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
    value: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
  },
  required: ['key', 'value'],
};

// Test schema for Excel template generation from dynamic JSONForms UI schema
export const opcComponentSampleUISchema = {
  type: 'VerticalLayout',
  action: 'scan',
  elements: [
    {
      type: 'Control',
      label: 'Copy Configuration From',
      scope: '#/properties/copy_configuration_from',
    },
    {
      type: 'Control',
      label: 'Root tag for scanning (Can be empty)',
      scope: '#/properties/scan_root',
    },
    {
      type: 'Control',
      label: 'Secrets - User Credentials',
      scope: '#/properties/secret_user_credentials',
    },
    {
      type: 'Control',
      label: 'Secrets - Auth Credentials',
      scope: '#/properties/secret_auth_credentials',
    },
    {
      type: 'Control',
      label: 'TLS Algorithm',
      scope: '#/properties/tls_algo',
    },
    {
      type: 'Control',
      label: 'Messages configured',
      scope: '#/properties/messages',
      options: {
        detail: {
          type: 'VerticalLayout',
          elements: [
            {
              type: 'Control',
              label: 'Message name',
              scope: '#/properties/id',
            },
            {
              type: 'Control',
              label: 'Message type',
              scope: '#/properties/type',
            },
            {
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/type',
                  schema: {
                    const: 'periodic',
                  },
                },
              },
              type: 'Control',
              label: 'Refresh Interval for polling',
              scope: '#/properties/refresh_interval',
            },
            {
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/type',
                  schema: {
                    const: 'trigger',
                  },
                },
              },
              type: 'Control',
              label: 'Read',
              scope: '#/properties/trigger',
            },
            {
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/type',
                  schema: {
                    const: 'trigger',
                  },
                },
              },
              type: 'Control',
              label: 'When',
              scope: '#/properties/comparison',
            },
            {
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#',
                  schema: {
                    properties: {
                      type: {
                        const: 'trigger',
                      },
                      comparison: {
                        not: {
                          const: 'changes',
                        },
                      },
                    },
                  },
                },
              },
              type: 'Control',
              label: 'Is',
              scope: '#/properties/value',
            },
            {
              type: 'Control',
              label: 'Parameters to be read',
              scope: '#/properties/props',
              options: {
                showSortButtons: false,
              },
            },
          ],
        },
        showSortButtons: false,
      },
    },
  ],
};
